import { render, staticRenderFns } from "./Compesation.vue?vue&type=template&id=1e95b9a8&scoped=true&"
import script from "./Compesation.vue?vue&type=script&lang=js&"
export * from "./Compesation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e95b9a8",
  null
  
)

export default component.exports